<template>
  <div class="pageContent alipayRedPacket">
    <LoadingModal />
    <div v-if="!$store.state.pageLoading">
      <Top :title="name" :message="tips" v-if="tips != ''" />
      <VTitle val="请选择面值" :showLine="false" />
      <TypeList
        :status="radio"
        :list="selList"
        :activeIndex="selItem"
        @selItem="handleSel"
        :isMember="isMember"
        :canSel="canSel"
        :vip_discount="vip_discount"
      />
      <VTitle val="充值账号" :showLine="false" />
      <div class="pageBigRadius pageCarServeShadow">
        <van-field
          v-model="account"
          class="pageBigRadius input"
          placeholder="请输入手机号码"
          :error-message="phoneErrorMsg"
          maxlength="11"
          @input="input"
          type="number"
          ref="accounts"
          id="accounts"
        />
      </div>
      <VTitle val="支付方式" :showLine="false" />
      <PayWay
        ref="payway"
        :placeholder="'请输入手机号码'"
        :sellData="sellData"
        :tips="tips"
        :discount="discount"
        :isWechatPay="wechatpay"
        :type="8"
        :params="params"
        :isSend="isSend"
        :balance="balance"
        :couponsId="couponsId"
        :couponsName="couponsName"
        :isMember="isMember"
        :vip_discount="vip_discount"
        :discount_coupons="discount_coupons"
        :can_use_power="can_use_power"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :accountIsValid="isValid"
        @onComfirm="payHandle"
      />
      <Tips>
        <div slot="content">
          <ul
            style="
              list-style: disc;
              color: #000;
              opacity: 0.53;
              margin-left: 15px;
            "
          >
            <li style="list-style: disc">
              <b>使用方法：</b>
              <p>
                支付宝APP首页->卡包 查看。支付时直接使用，不需要去第三方平台
              </p>
            </li>
            <li style="list-style: disc">
              <b>使用规则：</b>
              <p>
                1.支付宝消费红包通用券不可提现，不设找零，单次消费金额须比支付宝消费红包通用券面值大0.01元起方可使用；消费者每张订单只能用一张支付宝消费红包通用券，不可叠加使用，支付宝系统自动匹配符合使用条件的最大值红包使用，无需选择。
              </p>
              2.已派发且过期未用的支付宝消费红包通用券将自动作废，不予补发，请在有效期内使用。
              <p>
                3.支付宝消费红包通用券，可在线上线下全场景消费使用(提现、转账除外)。
              </p>
              <p>
                4.支付宝消费红包通用券通过手机号下发，支付宝支付时，需与兑换/发放目标手机号码保持一致，请注意使用该手机号绑定。
              </p>
              <p>
                5.支付宝消费红包通用券一经派发，概不退换，在派发订单前请认真核实账号。
              </p>
            </li>
          </ul>
        </div>
      </Tips>
    </div>
  </div>
</template>

<script>
import { getProductList } from "api/onLine";
import { submitPayOrder } from "api/submit";

export default {
  props: {
    type: String,
    name: String,
    cid: Number,
    balance: Number,
    couponsId: String,
    couponsName: String,
    couponsDeduct: Number,
    isMember: Boolean,
    ident: String,
    mouldId: String,
    couponsBalanceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      appimg: require("assets/sy.png"),
      radio: 0,
      area: "",
      // 数据列表
      selList: [],
      selItem: null,
      canSel: false, // 整个列表是否可选
      selListDefaultData: [],
      // 支付数据
      sellData: { sell_price: -1 },
      tips: "",
      describe: "",
      discount: 0,
      index: 0,
      wechatpay: false,
      account: "",
      params: { productId: "" },
      sms: "",
      isSend: true,
      data: {},
      vip_discount: 0,
      discount_coupons: [],
      can_use_power: false,
      phoneErrorMsg: "",
      isValid: false,
    };
  },
  created() {
    this.$store.commit("setPageLoading", false);
  },
  mounted() {
    this.loadData();
  },
  methods: {
    resetData() {
      this.selList = this.selListDefaultData.list;
      this.canSel = false;
      this.selItem = null;
      this.sellData = { sell_price: -1 };
    },
    loadData() {
      getProductList(this.ident, this.mouldId).then((res) => {
        this.$clear();
        if (res.status == 200) {
          if (typeof res.data == "object") {
            this.selList = res.data;
            this.canSel = true;
          }
        } else {
          this.resetData();
          this.$error(res.message);
        }
        this.$nextTick(() => {
          this.$store.commit("setPageLoading", false);
          this.$clear();
        });
      });
    },
    input(value) {
      if (!this.$regPhone(value)) {
        this.phoneErrorMsg = "手机号格式错误";
        this.isValid = false;
      } else {
        this.phoneErrorMsg = "";
        this.isValid = true;
      }
      this.params.account = this.account;
    },
    handleSel(i) {
      this.selItem = i;
      this.sellData = {
        ...this.selList[i],
        sell_price: Number(this.selList[i].productCustomerPrice),
      };
      this.params.productNo = this.selList[i].productNo;
      this.params.mouldId = this.mouldId;
    },
    payHandle(data) {
      this.$loading("订单处理中，请稍后...");
      submitPayOrder(data).then((res) => {
        if (res.status == 200) {
          setTimeout(() => {
            this.$successSync("下单成功", () => {
              this.$push({
                path: "/orders",
                query: { type: "-1" },
              });
            });
          }, 5000);
        } else {
          this.$error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.alipayRedPacket {
  /deep/ .van-field__control {
    color: #ff3300;
    font-size: 20px;
    font-weight: 900;
  }
}
</style>
